import React from 'react';
import { useParams } from 'react-router-dom';
import withTheme from '@material-ui/styles/withTheme';
import { Grid, CircularProgress } from '@material-ui/core';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import { ErrorIcon } from '../../../../icons';
import { useHistory } from 'react-router';
import { useNotify } from '../../../../hooks/useNotify';
import { useSwaggerClient, doSwaggerCall } from '../../../../hooks/useSwaggerClient';
import FormSection from '../../../../components/atom/FormSection';
import AdminHeader from '../../../../components/atom/AdminHeader';

function ChainEditForm({ theme }) {
    const { chainId } = useParams();
    const { notifyError, notifySuccess } = useNotify();
    const history = useHistory();
    const [chain, loading, error, setChain] = useSwaggerClient('chains', 'getChainById', {
        chainId: parseInt(chainId, 10)
    });

    const modifyChain = () => {
        doSwaggerCall('chains', 'updateChain', {
            chain,
            chainId: parseInt(chainId, 10)
        })
            .then(newChain => {
                setChain(newChain);
                notifySuccess('Chain modified!');
                history.push(`/admin/chains/list`);
            })
            .catch(() => {
                notifyError('Could not modify chain!');
            });
    };

    if (error) {
        return (
            <Grid container justifyContent="center">
                <h1>{error}</h1>
            </Grid>
        );
    }
    if (loading) {
        return (
            <Grid container justifyContent="center">
                <CircularProgress />
            </Grid>
        );
    }
    return (
        <Grid className="bg-white activity-edit">
            <form
                onSubmit={ev => {
                    ev.preventDefault();
                }}
            >
                <Grid container spacing={2}>
                    <AdminHeader title={`Chain edit`} />
                    {!!error && (
                        <Grid
                            item
                            container
                            spacing={2}
                            xs={12}
                            style={{
                                color: theme.palette.error.main
                            }}
                            alignItems="center"
                        >
                            <Grid item>
                                <ErrorIcon color="error" />
                            </Grid>
                            <Grid item>
                                <span>{error.response.body.message}</span>
                            </Grid>
                        </Grid>
                    )}
                    <FormSection title="Generic information">
                        <Grid item xs={12}>
                            <TextField
                                label="Name"
                                fullWidth
                                required
                                type="text"
                                value={chain ? chain.name : ''}
                                onChange={ev => setChain({ ...chain, name: ev.target.value })}
                            />
                        </Grid>
                    </FormSection>
                    <Grid item xs={6}>
                        <Button
                            fullWidth
                            variant="contained"
                            color="primary"
                            disabled={!chain.name}
                            onClick={() => {
                                modifyChain();
                            }}
                        >
                            Save
                        </Button>
                    </Grid>
                    <Grid item xs={6}>
                        <Button
                            fullWidth
                            variant="contained"
                            onClick={() => history.push(`/admin/chains/list`)}
                        >
                            Back
                        </Button>
                    </Grid>
                </Grid>
            </form>
        </Grid>
    );
}

export default withTheme(ChainEditForm);
